import React, { useCallback } from 'react'
import {
  actionButtonsColumnProps,
  BsrsGrid,
  DateCell,
  DateFilterCell
} from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import { useLocalization } from '@/hooks/localization'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import { useDialog } from '@/hooks/useDialog'
import { dialogTypes } from '@/dialogs'
import { AuditLogServiceName } from '@/internal-app/pages/auditLogs/customCell'

export function AuditLogs () {
  const { localize } = useLocalization()
  const openDialog = useDialog()
  const showDetailDialog = useCallback((item) => {
    openDialog({
      dialogType: dialogTypes.auditLog,
      item: item
    })
  }, [openDialog])

  return <Main>
    <MainTop>
      <MainTopTitle>
        <Resx name='Common.AuditLogs' />
      </MainTopTitle>
    </MainTop>

    <MainBody>
      <BsrsGrid
        persistenceId={'audit-logs'}
        dataSource={(request, options) => context.api.auditLogService.getTableData(request, options)}
        defaultSort={[{ field: 'executionTime', dir: 'desc' }]}
        filterable>
        <Column field='executionTime' width={160} title={localize('Common.Date')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
        <Column field='serviceName' title={localize('Common.ServiceName')} cell={AuditLogServiceName} editable={false} />
        <Column field='methodName' title={localize('Common.MethodName')} editable={false} />
        <Column field='userId' width={90} title={localize('Common.UserId')} editable={false} filter={'numeric'} />
        <Column field='userEmail' width={160} title={localize('Common.UserEmail')} editable={false} />
        <Column field='executionDuration' width={100} title={localize('Common.ExecutionDuration')} editable={false} filter={'numeric'} />
        <Column field='parameters' title={localize('Common.Parameters')} cell={YamlCell} editable={false} />
        <Column field='exception' title={localize('Common.Exception')} cell={YamlCell} editable={false} />
        <Column {...actionButtonsColumnProps([{ onClick: showDetailDialog, icon: 'show' }])} />
      </BsrsGrid>
    </MainBody>
  </Main>
}

const preStyle = { marginBottom: 0, maxHeight: 50, overflowY: 'auto' }

function YamlCell ({ dataItem, field }) {
  const val = (typeof (dataItem[field]) === 'object' ? JSON.stringify(dataItem[field]) : dataItem[field] || '').trim()
  return (
    <td>
      <pre style={preStyle}>
        <code>
          {val}
        </code>
      </pre>
    </td>
  )
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/auditLogs/list.js